import React from 'react';
import { COLORS } from '../../styles/UISystem';

/**
 * Color Swatch Component
 * Displays a color sample with name, hex code, and description
 */
export const ColorSwatch = ({ name, color, description }) => {
  return (
    <div style={{ marginBottom: '24px' }}>
      <div style={{ 
        backgroundColor: color, 
        height: '60px', 
        borderRadius: '8px',
        marginBottom: '8px'
      }} />
      <div style={{ fontWeight: 'bold', fontSize: '16px', color: COLORS.DARK_GRAY }}>
        {name}: {color}
      </div>
      <div style={{ fontSize: '14px', color: COLORS.DARK_GRAY }}>
        {description}
      </div>
    </div>
  );
};

// Export all colors with their descriptions
export const PRIMARY_COLORS = [
  { 
    name: 'LIGHT_GRAY', 
    color: COLORS.LIGHT_GRAY, 
    description: 'Form backgrounds, inactive buttons, stroke' 
  },
  { 
    name: 'MEDIUM_GRAY', 
    color: COLORS.MEDIUM_GRAY, 
    description: 'Placeholder text and images, disabled elements' 
  },
  { 
    name: 'MEDIUM_DARK_GRAY', 
    color: COLORS.MEDIUM_DARK_GRAY, 
    description: 'Selected icons, standard buttons' 
  },
  { 
    name: 'DARK_GRAY', 
    color: COLORS.DARK_GRAY, 
    description: 'Regular text, icons, header text, back icon' 
  },
  { 
    name: 'DISABLED_GRAY', 
    color: COLORS.DISABLED_GRAY, 
    description: 'Disabled forms' 
  },
  { 
    name: 'PRIMARY', 
    color: COLORS.PRIMARY, 
    description: 'Primary action buttons' 
  },
  { 
    name: 'PRIMARY_BLUE', 
    color: COLORS.PRIMARY_BLUE, 
    description: 'Entry button' 
  },
  { 
    name: 'MEDIUM_BLUE', 
    color: COLORS.MEDIUM_BLUE, 
    description: 'Send contact button' 
  }
];
